import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs, Outline } from 'react-pdf';
import { Button, GoBackButton } from '../../../elements/button';
import Spinner from '../../../elements/spinner';
import { useParams } from "react-router-dom";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const MyPDF = (props) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [outlines, setOutlines] = useState(null);
    const [url, setUrl] = useState(null);
    const [pageList, setPageList] = useState([]);

    function onDocumentLoadSuccess({ numPages, outline }) {
        setNumPages(numPages);
        setOutlines(outline);
        setLoading(false);
        //---
        setPageList(numPages)
    }
    const generateEmptyArray = (length) => {
        var arr = [];
        for (var i = 0; i < length; i++) {
            arr.push(0)
        }
        return arr;
    }
    useEffect(() => {
        setUrl(props.url);

    }, []);

    function handlePreviousPage() {
        setPageNumber(pageNumber - 1);
    }

    function handleNextPage() {
        setPageNumber(pageNumber + 1);
    }
    //--Get level from url 
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramsO = Object.fromEntries(urlSearchParams.entries());



    return (
        <div>

            {props.url && (
                <div>
                    {loading ? (
                        <
                            Spinner size="10" color="blue" />
                    ) : (
                        <><GoBackButton
                        link={`/teacher/features/library/?level=${paramsO.level}`}
                        action="Back"
                        location="PDF Book"
                      />{outlines && (
                            <div>
                                <h2>Table of Contents</h2>
                                <Outline items={outlines} />
                            </div>
                        )}
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ flex: 3 }}>
                                    <ul className="divide-y divide-blue h-100 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-100 p-3 bg-gray-200" style={{ height: "60vh", overflowY: 'scroll' }}>
                                        {generateEmptyArray(numPages).map((item, index) => {
                                            return <li onClick={() => {
                                                setPageNumber(index + 1)

                                            }} className={`py-2 cursor-pointer ${(index + 1 == pageNumber) ? "font-bold " : ""} `} key={index} style={{ color: "blue" }}><span  >Page {index + 1}</span></li>
                                        })}
                                    </ul>
                                </div>
                                <div style={{ flex: 7 }}><Document
                                    file={url}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    onLoadError={(error) => {
                                        setError(error);
                                        console.log(error)
                                        setLoading(false);
                                    }}
                                >
                                    <Page pageNumber={pageNumber} />
                                </Document></div>
                            </div>
                            <div style={{ padding: 20 }}>
                                {pageNumber > 1 && (
                                    <Button
                                        name="Previous Page"
                                        isSmall={true}
                                        outline="true"
                                        color="red"
                                        clicked={() => { handlePreviousPage() }} />
                                )}
                                {pageNumber < numPages && (
                                    <div style={{ float: "right" }}><Button
                                        name="Next Page"
                                        isSmall={true}
                                        outline="true"
                                        color="red"
                                        clicked={() => { handleNextPage() }} /></div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}

        </div>
    );
};

export default MyPDF;

